import api from './api';

export const getDashboardOverview = () => api.get('/dashboard/overview');

export const getSupervisorDashboard = (supervisorId) =>
  api.get(`/dashboard/supervisor/${supervisorId}`);
